import { PropsWithChildren, memo } from 'react';

import { ZapIcon } from 'lucide-react';

import { NameAvatar } from './NameAvatar';
import { Time } from './Time';

type Props = { userId?: string; time: string; created?: string; name?: string };

export const EventWrapper = memo(
  ({ userId, time, created, name, children }: PropsWithChildren<Props>) => {
    return (
      <div className="event mt-4 flex flex-wrap items-center justify-center gap-x-1 gap-y-0.5 px-4 py-2 [.event+&]:mt-0">
        {userId === 'brain' ? (
          <>
            <ZapIcon size={16} className="text-muted-foreground" />
            <span className="text-sm leading-5 font-semibold text-muted-foreground">{name}</span>
          </>
        ) : (
          <NameAvatar id={userId} name={name} />
        )}

        {children}
        <Time time={time} created={created} />
      </div>
    );
  }
);

EventWrapper.displayName = 'EventWrapper';
